var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.707 8.707a1 1 0 01-1.414 0L.929 2.343A1 1 0 012.343.93L8 6.586 13.657.929a1 1 0 111.414 1.414L8.707 8.707zM9 7v1H7V7h2z",
    fill: "#2E5ECC"
  })));
}

export default SvgArrowDown;